<template>
    <div class="loginbody modulewrap" :style="'background:url('+loginbg+')'">
        <div class="loginwrap">
            <div class="loginhome"><router-link to="/" :title="$common.dicword('homepage')"><i class="iconfont icon-home"></i></router-link></div>
            <div class="loginbg">
                <img :src="loginimg" />
            </div>
            <div class="loginlayer">
                <div class="loginarrow"></div>

                <div class="loginform">
                    <div class="logintitle">{{$common.dicword('memberlogin')}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-user"></i><input type="text" v-model="logininfo.username" class="txt" :placeholder="$common.dicword('usernamemobile')" maxlength="50" @focus="iserrusername=false" @blur="iserrusername=(logininfo.username=='')" />
                    </div>
                    <div class="loginmsg">{{strerrusername}}</div>
                    <div class="logininput">
                        <i class="iconfont icon-lock"></i><input type="password" v-model="logininfo.pwd" class="txt" :placeholder="$common.dicword('pwd')" maxlength="30" @focus="iserrpwd=false" @blur="iserrpwd=(logininfo.pwd=='')" />
                    </div>
                    <div class="loginmsg">{{strerrpwd}}</div>
                    <div class="logincheck">
                        <el-checkbox type="checkbox" v-model="logininfo.flag" :true-label="1" :false-label="0">{{$common.dicword('rememberme')}}</el-checkbox>
                    </div>
                    <div class="loginbtn"><a href="#" @click="login">{{issubmit?$common.dicword('logining'):$common.dicword('login')}}</a></div>
                    <div class="loginlink"><router-link to="/home/getpassword">{{$common.dicword('getpwd')}}</router-link><router-link to="/home/signup">{{$common.dicword('loginsignup')}}</router-link></div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                loginbg: '',
                loginimg: '',
                'logininfo': {
                    'username': '',
                    'pwd': '',
                    'flag': 0
                },
                'iserrusername': false,
                'iserrpwd': false,
                'issubmit': false,
                'myinterval': ''
            }
        },
        computed: {
            strerrusername: function () {
                return this.iserrusername ? this.$common.dicword('inputusername') : '';
            },
            strerrpwd: function () {
                return this.iserrpwd ? this.$common.dicword('needpwd') : '';
            }
        },
        methods: {

            login() {

                this.iserrusername = this.logininfo.username == '';
                this.iserrpwd = this.logininfo.pwd == '';

                let isallow = ((!this.iserrusername) && (!this.iserrpwd));
                if (isallow) {
                    this.issubmit = true;
                    let jsondata = {
                        'postdata': {
                            'api': 'member', 'act': 'login', "data": this.logininfo
                        }, 'msg': ''
                    };
                    this.$common.post(jsondata, (res) => {
                        this.$store.dispatch('setislogin', 1);
                        this.$store.dispatch('setmemlev', res.lev);
                        window.location = this.$store.state.tranurl;
                    }, () => {
                        this.issubmit = false;
                    });
                }

            }

        },
        mounted() {

            this.$emit('showheaderfooter', false);

            this.$common.fetch({ 'act': 'tea_login_img', 'msg': '' }, res => {
                this.loginbg = res.infodata.imgs;
                this.loginimg = res.infodataimg.imgs;
            });


            document.addEventListener('keyup', (e) => {
                var keycode = document.all ? window.event.keyCode : e.which;
                if (keycode == 13) {
                    this.login();
                }
            });
        }
    }
</script>
